/// <amd-module name="Feed/Legacy/Types/FeedState" />
import { HubViewState } from "VSSUI/Utilities/HubViewState";

import { FeedView, Package, PackageMetrics } from "Feed/Common/Contracts/Feed";
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { IPackageProtocol } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { IFeedUser } from "Feed/Legacy/Types/IFeedUser";
import { IMultiCommandDropdownVersions } from "Feed/Legacy/Types/IMultiCommandDropdownVersions";
import { RecycleBinState } from "Feed/Legacy/Types/RecycleBinState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

// tslint:disable:interface-name
export interface FeedState {
    feedUser: IFeedUser;
    displayWelcomeMessage: boolean;
    feedViews: FeedView[];
    feeds: Feed[];
    isNpmAllowUpstreamNameConflict: boolean;
    nextPageLoading: boolean;
    packages?: Package[];
    requestedPackageCount: number;
    packagesLoading: boolean;
    pageSize: number;
    protocolMap: { [key: string]: IPackageProtocol };
    selectedFeed: Feed;
    isMultiPromotePanelOpen: boolean;
    mruViewId: string;
    selectedPackages: Package[];
    multiCommandDropdownVersions: IMultiCommandDropdownVersions;
    hubState: HubViewState;
    showCreateBadgePanel: boolean;
    feedSettings: IFeedSettingsState;
    recycleBinState: RecycleBinState;
    /* True if custom upstream sources are enabled */
    isCustomPublicUpstreamsFeatureEnabled: boolean;
    /* True if project scoped upstreams are enabled */
    isProjectScopedUpstreamsFeatureEnabled: boolean;
    /* True to use new GlobalSettings panel */
    isGlobalPermMappedIdentifiersEnabled: boolean;
    /* Map to obtain package metrics given a package ID
       ie metrics[pkgid] = pkgMetrics
    */
    packageIdMetricsMap: { [key: string]: PackageMetrics };
    metricsEnabled: boolean;
    upstreamSourceLimit: number;
    /* True if Upstreams with Service Endpoints are enabled */
    isServiceEndpointUpstreamsFeatureEnabled: boolean;
}
